import logo from "../assets/images/etechcube_logo_square.png";

const WebApp_Name = "AVTC";
const company_logo_square = logo;
const gstin_no= "05AAAAT2562R1Z3";
export { WebApp_Name, company_logo_square,gstin_no };
